/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ManualRow,
    ManualRowFromJSON,
    ManualRowFromJSONTyped,
    ManualRowToJSON,
} from './';

/**
 * マニュアル一覧
 * @export
 * @interface ManualList
 */
export interface ManualList {
    /**
     * 
     * @type {Array<ManualRow>}
     * @memberof ManualList
     */
    manuals?: Array<ManualRow>;
}

export function ManualListFromJSON(json: any): ManualList {
    return ManualListFromJSONTyped(json, false);
}

export function ManualListFromJSONTyped(json: any, ignoreDiscriminator: boolean): ManualList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'manuals': !exists(json, 'manuals') ? undefined : ((json['manuals'] as Array<any>).map(ManualRowFromJSON)),
    };
}

export function ManualListToJSON(value?: ManualList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'manuals': value.manuals === undefined ? undefined : ((value.manuals as Array<any>).map(ManualRowToJSON)),
    };
}


